import { render, staticRenderFns } from "./ManageServicePopups.vue?vue&type=template&id=3f16681d&scoped=true&"
import script from "./ManageServicePopups.vue?vue&type=script&lang=js&"
export * from "./ManageServicePopups.vue?vue&type=script&lang=js&"
import style0 from "./ManageServicePopups.vue?vue&type=style&index=0&id=3f16681d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f16681d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f16681d')) {
      api.createRecord('3f16681d', component.options)
    } else {
      api.reload('3f16681d', component.options)
    }
    module.hot.accept("./ManageServicePopups.vue?vue&type=template&id=3f16681d&scoped=true&", function () {
      api.rerender('3f16681d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/ManageServicePopups.vue"
export default component.exports